import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { opportunityService } from '../services/api';

function formatUSD(n) {
  if (!n && n !== 0) return '—';
  return '$' + Number(n).toLocaleString('en-US');
}

export default function OpportunityList() {
  const [opportunities, setOpportunities] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState('');

  useEffect(() => {
    opportunityService.getAll()
      .then(data => setOpportunities(data.opportunities || []))
      .catch(() => setError('Failed to load opportunities'))
      .finally(() => setLoading(false));
  }, []);

  if (loading) return <div className="loading">Loading…</div>;
  if (error) return <div className="message error">{error}</div>;

  return (
    <div className="opportunity-list">
      <div className="list-header">
        <h2>My Opportunities</h2>
        <Link to="/submit" className="btn-primary ck-btn-primary">+ Submit New</Link>
      </div>

      {opportunities.length === 0 ? (
        <div className="empty-state">
          <p>No opportunities submitted yet.</p>
          <Link to="/submit" className="btn-primary ck-btn-primary">Submit your first opportunity</Link>
        </div>
      ) : (
        <div className="table-scroll">
          <table>
            <thead>
              <tr>
                <th>ID</th>
                <th>Opportunity</th>
                <th>Customer</th>
                <th>Deal Type</th>
                <th>ARR (USD)</th>
                <th>Close Date</th>
                <th>Stage</th>
                <th>Status</th>
                <th>Submitted</th>
                <th></th>
              </tr>
            </thead>
            <tbody>
              {opportunities.map(opp => (
                <tr key={opp.opportunity_id}>
                  <td><span className="cpn-id">{opp.cpn_id || '—'}</span></td>
                  <td><strong>{opp.opportunity_name}</strong></td>
                  <td>{opp.company_name}</td>
                  <td>
                    <div className="tag-stack">
                      {opp.deal_type && <span className="tag">{opp.deal_type}</span>}
                      {opp.ps_sub_category && <span className="tag tag-sub">{opp.ps_sub_category}</span>}
                      {opp.resell_sub_category && <span className="tag tag-sub">{opp.resell_sub_category}</span>}
                    </div>
                  </td>
                  <td>{formatUSD(opp.arr_usd)}</td>
                  <td>{opp.estimated_close_date ? new Date(opp.estimated_close_date).toLocaleDateString() : '—'}</td>
                  <td><span className="tag tag-stage">{opp.deal_stage || 'New'}</span></td>
                  <td>
                    <span className={`badge badge-${opp.status}`}>{opp.status}</span>
                  </td>
                  <td>{new Date(opp.created_at).toLocaleDateString()}</td>
                  <td>
                    <Link to={`/opportunities/${opp.opportunity_id}`} className="link-btn">View →</Link>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      )}
    </div>
  );
}
